<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 18:38:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-29 16:41:22
 * @name: 带查询筛选的表格
 * @Description: 带查询筛选的表格
 * @FilePath: \preSaleNafterSaleBackstage\src\components\public\table-search-form.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="tableSearchForm">
    <container-float-title title="搜索条件">
      <slot name="searchForm" />
    </container-float-title>
    <container-float-title :title="title">
      <table-normal class="tableNormal">
        <template v-slot:title>
          <slot name="title" />
        </template>
        <template v-slot:head>
          <slot name="head" />
        </template>
        <template v-slot:bar>
          <slot name="bar" />
        </template>
        <template v-slot:table>
          <slot name="table" />
        </template>
        <template v-slot:pagination>
          <slot name="pagination" />
        </template>
      </table-normal>
    </container-float-title>
  </div>
</template>
<script>
import containerFloatTitle from "./container-float-title.vue";
import tableNormal from "@/components/public/table-normal.vue";

export default {
  name: "tableSearchForm",
  components: { containerFloatTitle, tableNormal },
  props: {
    title: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.tableSearchForm {
  @include grid-row(2, auto, 20px);

  /deep/.search-form {
    box-sizing: border-box;
    width: 100%;
    @extend .extend-flex-column-normal;
    padding: 0 20px;
    .search-line {
      @extend .extend-flex-normal;
      width: 100%;
      margin-top: calc(#{$Var-height-mini} / 2);
      &:nth-child(1) {
        margin-top: 0;
      }
      .search-label {
        min-width: calc(#{$Vars-font-miniContent-size} * 5);
        font-size: $Vars-font-miniContent-size;
        text-align: left;
        margin-right: calc(#{$Var-height-mini} / 4);
        line-height: $Var-height-mini;
      }
      .search-content {
        flex: 1;
        @extend .extend-flex-normal;
        .el-input {
          width: calc(#{$Var-height-mini} * 8);
        }
        .search-checkbox-group {
          flex: 1;
          @extend .extend-flex-normal;
          .select-all {
            line-height: $Var-height-mini;
            font-size: $Vars-font-miniContent-size;
            margin-right: 15px;
            margin-bottom: 10px;
            flex-shrink: 0;
            @extend .extend-clickElement;
            &.actived {
              color: $Vars-normal-color;
            }
          }
          .el-checkbox-button {
            margin-right: 5px;
            margin-bottom: 10px;
          }
          .el-radio-button {
            margin-right: 5px;
            margin-bottom: 10px;
          }
          &.showLess {
            overflow: hidden;
            height: calc(#{$Var-height-mini} + 10px);
          }
        }
      }
      .search-more {
        font-size: $Vars-font-miniContent-size;
        text-align: right;
        margin-left: calc(#{$Var-height-mini} / 4);
        line-height: $Var-height-mini;
        @extend .extend-clickElement;
        font {
          margin-right: 5px;
        }
        &:hover {
          color: $Vars-normal-color;
        }
      }
    }
    .btn-group{
      margin-top: calc(#{$Var-height-mini} / 2);
      margin-left: calc(#{$Vars-font-miniContent-size} * 5 + #{$Var-height-mini} / 4);
      @extend .extend-flex-start;
    }
  }
  /deep/ .el-checkbox-button--mini .el-checkbox-button__inner {
    border: none !important;
    font-size: $Vars-font-miniContent-size !important;
    border-radius: 4px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  /deep/ .el-radio-button--mini .el-radio-button__inner {
    border: none !important;
    font-size: $Vars-font-miniContent-size !important;
    border-radius: 4px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  /deep/
    .el-radio-button:first-child
    .el-radio-button__orig-radio:checked
    + .el-radio-button__inner {
    background: none !important;
    color: #4093ff;
    box-shadow: none !important;
  }
  /deep/
    .el-radio-button:first-child
    .el-radio-button__orig-radio
    + .el-radio-button__inner {
    padding: 0 !important;
    margin-right: 10px;
  }
  .tableNormal {
    width: 100%;
    margin: 0;
  }
}
</style>
